import React from 'react';
import PropTypes from 'prop-types';
import FormattedLink from '@stubhub/react-formatted-link';
import {Button} from '@stubhub/bamboo';
import NavMenuOptionList from './nav-menu-option-list';
import NavSubCatList from './nav-sub-category-list';
import ModalMask from '@stubhub/react-modal-mask';
import Logo from '@stubhub/react-logo';
import GeoFilter from '@stubhub/react-geo-filter';
import disableScreenScrolling from '@stubhub/react-disable-screen-scrolling';

import '../styles/nav-menu.scss';
const ModalMaskCmp = disableScreenScrolling(ModalMask);
class NavMenu extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object
  };

  constructor(props, context) {
    super(props);
    this.state = {
      active: props.active || false
    };
    const {globalRegistry} = context;

    this.enableSubCatNav = globalRegistry && globalRegistry.getFeatureValue('common.enableSubCatNav');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      active: nextProps.active || false
    });
  }

  onItemClick = () => {
    const {onItemClick, id, items} = this.props;
    if (typeof onItemClick === 'function') {
      onItemClick(id, items);
    }
  };

  /*
   * Invoked when a menu option is clicked
   * Should be attached to an onClick event to properly trigger
   */
  onOptionClick = (evt) => {
    const id = evt.target.dataset.itemId || evt.target.dataset.index;
    const categoryId = evt.target.dataset.id || '';
    const columnIndex = evt.target.dataset.columnindex || '';
    const {onOptionClick} = this.props;
    if (typeof onOptionClick === 'function') {
      onOptionClick(id, categoryId, columnIndex);
    }
  }

  /*
   * Invoked when user clicks outside of the menu option list
   */
  onClickOutside = () => {
    const {onClickOutside} = this.props;
    if (typeof onClickOutside === 'function') {
      onClickOutside(this.props.id);
    }
  }

  /*
   * Invoked when user hovers over a menu option or category sub menu option
   */
  onItemHover = () => {
    const {onMenuHover, onCategoryHover, id, items} = this.props;
    if (items) {
      if (typeof onMenuHover === 'function') {
        onMenuHover(id, items);
      }
    } else if (typeof onCategoryHover === 'function') {
        onCategoryHover(id);
      }
  };

  render() {
    const {label, href, items, id, toggleLabel, noFormat, isSellLanding} = this.props;
    const {active} = this.state;
    const hasItems = items && items.length;
    const headerCls = `mh__nav-menu-header ${active ? 'mh__nav-menu-header--active' : ''} ${hasItems ? 'mh__nav-menu-header--has-children' : ''}`;
    let dropdown = null;
    let mask = null;
    const {screenSize} = this.props;

    if (active) {
      if (items && items.length) {
        // Dropdown for mweb breakpoints informs the menu modal that appears when clicked from the nav
        if (screenSize === 'small') {
          dropdown = (
            <div className="mh__nav-dropdown-container">
              <div className="sh-iconset sh-iconset-close mh__nav-menu__close-icon" onClick={this.onClickOutside} />
              <div className="mh__nav-menu-modal">
                <div className="mh__nav-menu-modal__heading">
                  <Logo onItemClick={this.onItemClick}/>
                  <GeoFilter className="merch-geo-filter--dropdown"/>
                </div>
                <div className="mh__nav-menu-options">
                  <NavMenuOptionList items={items[0].items} href={href} onOptionClick={this.onOptionClick}/>
                  <NavMenuOptionList items={items[1].items} href={href} onOptionClick={this.onOptionClick}/>
                  <NavMenuOptionList items={items[2].items} href={href} onOptionClick={this.onOptionClick}/>
                </div>);
              </div>
            </div>);
        } else {
          dropdown = (
            <div className="mh__nav-menu-options">
              <NavMenuOptionList items={items} href={href} onOptionClick={this.onOptionClick} onClickOutside={this.onClickOutside} />
            </div>);
        }
      }
      // Dropdown for sub category navigation when user hovers over genre category options
      if (this.enableSubCatNav && screenSize !== 'small' && id && (id === 'sports' || id === 'concerts' || id === 'theater-comedy')) {
        dropdown = <NavSubCatList id={id} onOptionClick={this.onOptionClick} onClickOutside={this.onClickOutside} />;
      }

      // Show a mask only for small screen sizes
      mask = (screenSize === 'small') ? (
        <div>
          <ModalMaskCmp extraCls="mh__nav-menu-mask--background" onClick={this.onClickOutside}/>
        </div>) : null;
    }

    const linkIcon = (
      <span className={`mh__nav-menu-icon menu__icon-${id} ${active ? 'mh__nav-menu-icon--active' : ''}`}/>
    );

    const linkText = (
      <span className={`mh__nav-menu-header-text menu__header-text-${id}`}>{active && toggleLabel ? toggleLabel : label}</span>
    );

    const link = noFormat ? (
      <a className={headerCls} href={href} onClick={this.onItemClick} aria-label={label}>
        {linkText}
        {linkIcon}
      </a>
    ) : (
      <FormattedLink className={headerCls} href={href} onClick={this.onItemClick} aria-label={label}>
        {linkText}
        {linkIcon}
      </FormattedLink>
    )

    return (
      <div className={`mh__nav-menu ${active ? 'mh__nav-menu--active' : ''}`} id={label} onMouseOver={this.onItemHover}>
        <Button appearance={isSellLanding ? 'ghost' : 'secondary'}>{link}</Button>
        {dropdown}
        {mask}
      </div>
    );
  }
}

NavMenu.propTypes = {
  items: PropTypes.array,
  isSellLanding: PropTypes.bool,
  label: PropTypes.string,
  active: PropTypes.bool,
  href: PropTypes.string,
  id: PropTypes.string,
  onItemClick: PropTypes.func,
  onOptionClick: PropTypes.func,
  onClickOutside: PropTypes.func,
  onMenuHover: PropTypes.func,
  onCategoryHover: PropTypes.func,
  screenSize: PropTypes.string
};

NavMenu.defaultProps = {
  active: false,
  screenSize: 'small'
};

export default NavMenu;
